import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import axios from "axios";
import { Lock } from "lucide-react";
import { API, setToken, getToken } from "../lib/auth";

export default function AdminLogin() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (getToken()) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, form);
      setToken(data.access_token);
      toast.success("Bienvenue " + data.admin.name);
      navigate("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail || "Erreur de connexion";
      toast.error(typeof detail === "string" ? detail : "Erreur de connexion");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center bg-[#09090b] px-5">
      <div className="pointer-events-none absolute inset-0 opacity-20">
        <div className="absolute left-1/2 top-1/2 h-[80vmin] w-[80vmin] -translate-x-1/2 -translate-y-1/2 rounded-full border border-[#FF0000]/40" />
      </div>

      <div className="relative w-full max-w-md">
        <div className="mb-8 flex items-center gap-3">
          <span className="font-display text-3xl leading-none tracking-tight text-[#FF0000]">
            AKTRA
          </span>
          <span className="font-mono-x text-[10px] uppercase tracking-[0.3em] text-zinc-500">
            · admin
          </span>
        </div>

        <div className="border border-white/10 bg-white/[0.02] p-8 backdrop-blur-xl">
          <div className="mb-6 flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center border border-white/15 bg-white/5">
              <Lock className="h-4 w-4 text-[#FF0000]" />
            </div>
            <div>
              <h1 className="font-display text-2xl uppercase tracking-tight text-white">
                Espace admin
              </h1>
              <p className="font-mono-x text-[10px] uppercase tracking-[0.25em] text-zinc-500">
                Éclipse · Flow · Paris
              </p>
            </div>
          </div>

          <form onSubmit={submit} data-testid="admin-login-form" className="space-y-5">
            <div>
              <label className="mb-2 block font-mono-x text-[10px] uppercase tracking-[0.25em] text-zinc-500">
                Email
              </label>
              <input
                data-testid="admin-input-email"
                type="email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                required
                className="w-full border border-white/15 bg-white/5 px-4 py-3 text-white outline-none transition-colors duration-300 placeholder:text-zinc-600 focus:border-[#FF0000]"
                placeholder="admin@aktra.paris"
              />
            </div>
            <div>
              <label className="mb-2 block font-mono-x text-[10px] uppercase tracking-[0.25em] text-zinc-500">
                Mot de passe
              </label>
              <input
                data-testid="admin-input-password"
                type="password"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                required
                className="w-full border border-white/15 bg-white/5 px-4 py-3 text-white outline-none transition-colors duration-300 placeholder:text-zinc-600 focus:border-[#FF0000]"
                placeholder="••••••••"
              />
            </div>
            <button
              type="submit"
              data-testid="admin-login-submit"
              disabled={loading}
              className="glow-red w-full bg-[#FF0000] px-6 py-4 font-mono-x text-sm font-semibold uppercase tracking-[0.15em] text-white hover:bg-[#ff2424] disabled:opacity-60"
            >
              {loading ? "Connexion..." : "Se connecter"}
            </button>
          </form>
        </div>

        <a
          href="/"
          data-testid="admin-back-home"
          className="mt-6 inline-block font-mono-x text-[10px] uppercase tracking-[0.25em] text-zinc-500 link-underline"
        >
          ← Retour au site
        </a>
      </div>
    </div>
  );
}
